import { gql } from '@apollo/client';

const GET_FORM_SECTION_BY_SLUG = gql`
  query GetSectionBySlug($slug: String!) {
    sectionsBy(slug: $slug) {
      htmlPersonalizado {
        htmlTitle
        htmlContent
      }
    }
  }
`;

export { GET_FORM_SECTION_BY_SLUG }